export default __webpack_public_path__ + "static/media/2_icon5A.ff05a3b1.png";